import React from "react"
import {Welcome} from "src/components/welcome";

export default function App() {
  return (
    <Welcome/>
  );
}
